module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_03-4ad22ccc707b263ca5f229df39b866ce.webp";